import styled from 'styled-components';

interface BadgeProps {
  children?: React.ReactNode;
  className?: string;
  iconLeft?: JSX.Element;
}

const Badge = ({ children, className = '', iconLeft }: BadgeProps) => (
  <div className={className}>
    {iconLeft && <span className="icon-left">{iconLeft}</span>}
    <span className="name">{children}</span>
  </div>
);

const BadgeStyled = styled(Badge)`
  font-size: 0.75rem;
  line-height: 1.166666666666667;
  border: 0.0625rem solid transparent;
  border-radius: 0.125rem;
  display: inline-flex;
  align-items: center;

  &.info {
    color: ${({ theme }) => theme.primaryText};
    border-color: ${({ theme }) => theme.primaryBackgroundActive};
    background-color: ${({ theme }) => theme.primaryBackground};
  }

  &.warning {
    color: ${({ theme }) => theme.warningText};
    border-color: ${({ theme }) => theme.warningBackgroundActive};
    background-color: ${({ theme }) => theme.warningBackground};
  }

  &.success {
    color: ${({ theme }) => theme.successText};
    border-color: ${({ theme }) => theme.successBackground};
    background-color: ${({ theme }) => theme.successBackground};

    .icon-left {
      border-color: ${({ theme }) => theme.successBackgroundMedium};
    }
  }

  &.danger {
    color: ${({ theme }) => theme.alertText};
    border-color: ${({ theme }) => theme.alertBackground};
    background-color: ${({ theme }) => theme.alertBackground};

    .icon-left {
      border-color: ${({ theme }) => theme.alertBackgroundMedium};
    }
  }

  .name {
    padding: 0.125rem 0.1875rem;
  }

  .icon-left {
    display: inline-flex;
    border-right-width: 0.0625rem;
    border-right-style: solid;
    padding: 0.1875rem 0.25rem 0.1875rem;
    margin-right: 0.0625rem;
  }
`;

export default BadgeStyled;
